import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {scrollTriggerConfig, duration, scrolling} from "./animation";
import {setActiveNavItem} from "./nav";

const animateVideo = () => {
  const sectionId = 'video';
  const sectionDuration = duration[sectionId];

  const el = {
    main: '.section-video__main',
    video: '.section-video .embed__media',
  };

  const animate = (direction) => {
    return {
      enter: {
        main: {
          from: { y: `${75 * direction}vh`, autoAlpha: 0 },
          to: { y: 0, autoAlpha: 1 },
        },
        video: {
          from: { scale: .5, autoAlpha: 0 },
          to: { scale: 1, autoAlpha: 1 },
        },
      },
    }
  };

  ScrollTrigger.create({
    id: sectionId,
    trigger: `.section-${sectionId}`,
    ...scrollTriggerConfig,
    onEnter: (self) => {
      setActiveNavItem();

      scrolling.disable();

      gsap.fromTo(el.main, { ...animate(1).enter.main.from }, { ...animate(1).enter.main.to, duration: sectionDuration });
      gsap.fromTo(el.video, { ...animate(1).enter.video.from }, { ...animate(1).enter.video.to, duration: sectionDuration })
      .then(scrolling.enable);
    },
    onLeave: (self) => {
      scrolling.disable();
      gsap.to(el.main, { ...animate(-1).enter.main.from, duration: sectionDuration });
      gsap.to(el.video, { ...animate(-1).enter.video.from, duration: sectionDuration })
      .then(scrolling.enable);
    },
    onEnterBack: (self) => {
      setActiveNavItem();
      scrolling.disable();

      gsap.fromTo(el.main, { ...animate(-1).enter.main.from }, { ...animate(-1).enter.main.to, duration: sectionDuration });
      gsap.fromTo(el.video, { ...animate(-1).enter.video.from }, { ...animate(-1).enter.video.to, duration: sectionDuration })
      .then(scrolling.enable);
    },
    onLeaveBack: (self) => {
      scrolling.disable();
      gsap.to(el.main, { ...animate(1).enter.main.from, duration: sectionDuration });
      gsap.to(el.video, { ...animate(1).enter.video.from, duration: sectionDuration })
      .then(scrolling.enable);
    },
  });
}

export default animateVideo;
